import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import Component from './Component.jsx';

const InlineMath = Node.create({
  name: 'inlineMath',
  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      value: {
        default: ' ',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'inline-math',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['inline-math', HTMLAttributes, 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(Component);
  },
});

export default InlineMath;
